var TorsoBehavior = require('backbone-torso/modules/Behavior');
var WizardWidget = require('./WizardWidget');

/**
 * Perspective for sharing functionality (mainly retrieving the wizard) between views.
 *
 * Expectation is that the wizard id properties are saved on the view.  Override getWizardId() in the view if they are not.
 * Expected properties:
 *   patientVecnaId: view._patientVecnaId
 *   appointmentExternalId: view._appointmentExternalId
 *   regDate: view._regDate
 *
 * See WizardWidget for details.
 *
 * @class WizardPerspectiveBehavior
 */
module.exports = TorsoBehavior.extend({
  mixin: {
    /**
     * Convenience method to get the wizard widget identified by this view.
     * @method getWizardWidget
     * @return {WizardWidget} an instance of the wizard widget for the given patientVecnaId and appointmentExternalId
     */
    getWizardWidget: function() {
      return WizardWidget.getWizardWidget(this.view.getWizardId());
    },

    /**
     * Override this if the properties aren't saved in the expected places in the view.
     *
     * patientVecnaId: view._patientVecnaId
     * appointmentExternalId: view._appointmentExternalId
     * regDate: view._regDate
     *
     * @method getWizardId
     * @return {Object} the info needed to get or retrieve a wizard.
     */
    getWizardId: function() {
      return {
        patientVecnaId: this.view._patientVecnaId,
        appointmentExternalId: this.view._appointmentExternalId,
        regDate: this.view._regDate
      };
    }
  }
});
